import { OverallRatingBlock, OverallRatingBlockProps } from 'common/components/overall-rating-block';
import { getReviewsGroupRatingTotal } from 'features/reviews/selectors';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';

export const mapStoreToProps = (store: RootReducer): OverallRatingBlockProps => {
  const totalRatingMeta = getReviewsGroupRatingTotal(store);

  return {
    numberOfRatings: totalRatingMeta?.countReview ?? -1,
    ratingValue: totalRatingMeta?.scoreRating ?? -1,
  };
};

export const PdpOveralRating = connect(mapStoreToProps, null, (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
}))(OverallRatingBlock);
